export default x => () => x;



//////////////////
// WEBPACK FOOTER
// ./~/d3-brush/src/constant.js
// module id = 442
// module chunks = 0